import { vehicle_details_best_for } from '@porterin/feature/src/shared/core/constants/VehicleStoreEn';
import {
  MIN_WIDTH_DESKTOP,
  useMediaQuery,
} from '@porterin/feature/src/shared/core/hooks/useMediaQuery';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import { VehicleModalData } from '../../types';
import styles from '../styles/VehicleDetails.module.scss';

import VehicleCapacityCmp from './VehicleCapacityCmp';

interface VehicleDetailsCmpProps {
  vehicle: VehicleModalData;
  title: string;
}

function VehicleDetailsCmp({
  vehicle,
  title,
}: Readonly<VehicleDetailsCmpProps>): React.ReactElement {
  const isDesktop = useMediaQuery(MIN_WIDTH_DESKTOP);
  const imageWidth = isDesktop ? 226 : 113;
  const imageHeight = isDesktop ? 140 : 70;

  return (
    <section className={styles['title-container']}>
      <div className={styles['vehicle']}>
        <div className={styles['vehicle-image']}>
          <NextImageV2
            src={vehicle.image_src}
            alt={vehicle.alt_text}
            width={imageWidth}
            height={imageHeight}
          />
        </div>
        <div className={styles['vehicle-weight-desktop']}>
          <VehicleCapacityCmp
            icon={vehicle.capacity_icon}
            capacity={vehicle.capacity}
          />
        </div>
        <div className={styles['vehicle-text']}>
          <h3 className={styles['vehicle-name']}>{vehicle.vehicle_name}</h3>
          <div className={styles['vehicle-fare']}>
            <ReactMarkdown>{vehicle.vehicle_fare}</ReactMarkdown>
          </div>
          <div className={styles['vehicle-weight-mobile']}>
            <VehicleCapacityCmp
              icon={vehicle.capacity_icon}
              capacity={vehicle.capacity}
            />
          </div>
        </div>
      </div>
      {vehicle.best_for_sending.length > 0 && (
        <>
          <div className={styles['divider']} />
          <div className={styles['best-for-section-wrapper']}>
            <h3 className={styles['best-for-section-title']}>
              {vehicle_details_best_for}
            </h3>
            <div className={styles['best-for-wrapper']}>
              {vehicle.best_for_sending.map(data => (
                <div className={styles['best-for']} key={data.category}>
                  <div className={styles['best-for-image']}>
                    <NextImageV2
                      src={data.image.path}
                      alt={data.image.alt_text}
                      width={20}
                      height={20}
                    />
                  </div>
                  <p className={styles['best-for-title']}>{data.category}</p>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      <div className={styles['divider-mobile']} />
      <h2 className={styles['title-mobile']}>{title}</h2>
    </section>
  );
}

export default VehicleDetailsCmp;
